import React from 'react'
import Icon from 'components/common/Icon'
import { ToolTip, useTooltip } from 'components/common/ToolTip'

const HelpTip = ({ children }) => {
  const [props, toolTipProps] = useTooltip()
  return (
    <span className="HelpTip" {...props}>
      <Icon name="helpCircle" />
      <ToolTip {...toolTipProps} order={'top right bottom left'}>
        <div className="help-text">{children}</div>
      </ToolTip>
    </span>
  )
}

export default HelpTip
